module.exports = __webpack_public_path__ + "img/RedButton.c4ea8d97.png";